module.exports = __webpack_public_path__ + "img/raia.a8d11ea5.jpg";